<script>
	import { Icon, DialogNew } from '@shopboxai/sb-portal-components';
	import { updateUserPermissions } from '../../utils/api.js';
	import { createEventDispatcher } from 'svelte';
	import { notifications } from '@shopboxai/sb-portal-components';
	import { onMount } from 'svelte';
	const dispatch = createEventDispatcher();

	export let data;
	let permissions = {};

	const submitUpdate = async () => {
		try {
			notifications.info('Updating permissions...', 2000);
			await updateUserPermissions(permissions, data.user_id);
			notifications.success('Permissions have been updated', 2000);
		} catch (error) {
			notifications.danger('Soemthing went wrong', 2000);
		} finally {
			dispatch('complete');
		}
	};
	const resetPermissions = () => {
		permissions = { ...data.permissions };
	};

	const handleClose = () => {
		resetPermissions();
	};

	onMount(async () => {
		resetPermissions();
	});
</script>

<DialogNew on:submit={submitUpdate} on:close={handleClose}>
	<div slot="header">
		Edit <br /> <span class="sub-header">{data.email}</span>
	</div>
	<button slot="toggle">
		<Icon name="settings" />
	</button>
	<div slot="content">
		<div class="main">
			{#each Object.keys(data.permissions) as permission}
				<label for={permission}>
					<span> {permission}</span>
					<input
						id={permission}
						name={permission}
						type="checkbox"
						bind:checked={permissions[permission]}
					/>
				</label>
			{/each}
		</div>
	</div>
	<button class="primary" slot="primary-action"> Update </button>
</DialogNew>

<style>
	div[slot='header'] {
		text-align: left;
	}
	button.primary:disabled {
		filter: brightness(1.75);
		cursor: unset;
		pointer-events: none;
	}
	.sub-header {
		font-size: 13px;
		font-weight: 300;
	}
	.main {
		padding: 0 30px;
	}
	label {
		display: flex;
		justify-content: space-between;
	}
	label > span {
		font-size: 16px;
		font-weight: 400;
	}
	input {
		accent-color: var(--p-c);
		width: 20px !important;
		height: 20px;
	}
</style>
